export enum ProtocolConsumptionConditionEnum {
    Normal = 1,
    ScreeningFailure = 2,
    EarlyDiscontinuation = 3,
    FollowUp = 4,
}
